<template>
  <quiz-layout>
    <template #header>
      <h2 v-if="getUserDetail" class="text-capitalize">Welcome Back, {{getUserDetail.name}}</h2>
    </template>
    <template #sidebar>
      <div class="sidebar__menu">
        <div class="menu__item">
          <div class="item__icon">
            <svg viewBox="0 0 27 28" fill="none">
              <g clip-path="url(#clip0_79_12403)">
                <path
                  d="M13.5 0L0.5 9.88235V28H9.30645V17.2941H17.6935V28H26.5V9.88235L13.5 0Z"
                  fill="#F1BC04"
                />
              </g>
              <defs>
                <clipPath id="clip0_79_12403">
                  <rect
                    width="26"
                    height="28"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="item__title">Home</div>
        </div>
      </div>
    </template>
    <template>
      <div class="content__header">
        <div class="content__title">Quiz In Progress</div>
        <div class="content__summary">
          <div class="summary__item">
            In Progress
            <span class="summary__number">{{ inProgress.length }}</span>
          </div>
          <div class="summary__item">
            Completed
            <span class="summary__number">{{ completed.length }}</span>
          </div>
        </div>
        <div class="content__progressbar">
          <div class="content__progress" :style="computedProgress" />
        </div>
      </div>
      <div class="content__section">
        <div class="section__title">In Progress</div>
        <div class="content__group">
          <template v-if="inProgress.length === 0">
            <div class="group__item">
              <div class="group__title">
                You dont't have any quiz in progress.
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="group__item"
              v-for="(item, key) in inProgress"
              :key="key"
            >
              <div class="group__title">
                <a
                  :href="`http://classroom.concinnitylimited.com/classroomcategory/${item.slug}`"
                >
                  {{ item.name }}
                </a>
              </div>
              <router-link :to="`/quiz/${item.slug}`">
                <div class="group__action">Continue</div>
              </router-link>
            </div>
          </template>
        </div>
      </div>
      <div class="content__section">
        <div class="section__title">Completed</div>
        <div class="content__group">
          <template v-if="completed.length === 0">
            <div class="group__item">
              <div class="group__title">You haven't completed any Quiz.</div>
            </div>
          </template>
          <template v-else>
            <div
              class="group__item"
              v-for="(item, key) in completed"
              :key="key"
            >
              <div class="group__title">{{ item.name }}</div>
              <router-link :to="`/quiz/${item.slug}`">
                <div class="group__action group__action--completed">
                  Continue
                </div>
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </template>
  </quiz-layout>
</template>
<script>
import { AccountService } from "../data/services/account.service";
import QuizLayout from "../layout/QuizLayout.vue";
export default {
  components: { QuizLayout },
  name: "Account",
  data() {
    return {
      inProgress: [],
      completed: [],
    };
  },
  computed: {
    computedProgress() {
      const completedLength = this.completed.length;
      const inProgressLength = this.inProgress.length;

      let width = 0;
      if (completedLength !== 0 && inProgressLength !== 0) {
        width = (completedLength / inProgressLength) * 100;
      }

      return {
        width: `${width}px`,
      };
    },
    getUserDetail() {
      return this.$store.getters["auth/getUserDetailState"]
    }
  },
  mounted() {
    this.getProgress();
  },
  methods: {
    // async getProfile () {
    //   const accountService = new AccountService();
    //   await accountService.getUserProfile().then(response => {
    //     console.log('response => ', response)
    //
    //   })
    // },
    async getProgress() {
      const accountService = new AccountService();
      const progressStatus = await accountService.getQuizProgress();
      progressStatus.forEach((progress) => {
        if (progress._id === "inprogress") {
          this.inProgress = progress.lessons.filter((lesson) => {
            return lesson.name !== undefined;
          });
          return;
        }
        if (progress._id === "completed") {
          this.completed = progress.lessons.filter((lesson) => {
            return lesson.name !== undefined;
          });
          return;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$sidebar-width: 211px;
.page {
  width: 100%;
  display: flex;
  justify-content: center;

  .sidebar {
    &__menu {
      display: flex;
      flex-direction: column;
    }
  }

  .menu {
    &__item {
      display: flex;
      cursor: pointer;
      align-items: center;
    }
  }

  .item {
    &__icon {
      width: 26px;
      margin-right: 15px;
      svg {
        width: 100%;
      }
    }
    &__title {
      color: #f1bc04;
      font-size: 20px;
      line-height: 24px;
    }
  }

  .content {
    &__title {
      font-weight: 500;
      font-size: 30px;
      line-height: 35px;
      margin-bottom: 30px;
    }
    &__summary {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 24px;
    }
    &__progressbar {
      border-radius: 20px;
      width: 100%;
      height: 7px;
      background: #d9d9d9;
      margin-bottom: 20px;
    }
    &__progress {
      height: 7px;
      width: 50%;
      background: #f1bc04;
      border-radius: 20px;
    }
    &__section {
      + .content__section {
        margin-top: 20px;
      }
    }

    &__group {
      padding: 20px;
      width: 100%;
      background: white;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
    }
  }
  .summary {
    &__item {
      + .summary__item {
        margin-left: 10px;
      }
    }
  }

  .section {
    &__title {
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 22px;
      line-height: 24px;
      color: #000000;
    }
  }

  .group {
    &__item {
      display: flex;
      align-content: center;
      justify-content: space-between;
      + .group__item {
        margin-top: 10px;
      }
    }
    &__title {
      font-size: 16px;
      align-self: center;
    }
    &__action {
      cursor: pointer;
      font-size: 14px;
      padding: 4px 15px;
      background: #024089;
      color: #ffffff;
      border-radius: 20px;
      &--completed {
        background: #f1bc04;
      }
    }
  }
}
</style>
